// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editable-text-area{min-height:40px !important;padding:10px 8px}", "",{"version":3,"sources":["webpack://./src/templates/instructions/codeReviewV2/codeReviewCommentEditor.scss"],"names":[],"mappings":"AAAA,oBACE,0BAAA,CACA,gBAAA","sourcesContent":[".editable-text-area {\n  min-height: 40px !important;\n  padding: 10px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
